import { render } from "./BankIdLogin.vue?vue&type=template&id=e36f491c&scoped=true"
import script from "./BankIdLogin.vue?vue&type=script&lang=js"
export * from "./BankIdLogin.vue?vue&type=script&lang=js"

import "./BankIdLogin.vue?vue&type=style&index=0&id=e36f491c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36f491c"]])

export default __exports__